import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose, withApollo } from 'react-apollo';
import _ from 'lodash';
import moment from 'moment';
// material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import Search from '@material-ui/icons/Search';
import { Grid } from '@material-ui/core';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { CSVLink } from 'react-csv';
import { FaFileExport } from 'react-icons/fa';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';

import { getAllDealCoinsMovements } from './queries';
import { Dialog } from '../../../components';
import CustomInput from '../../../components/CustomInput/CustomInput';
import styles from './styles';
import colors from '../../../constants/colors';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class TableDealCoins extends Component {
  state = {
    open: false,
    title: '',
    content: '',
    page: 1,
    limit: 15,
    fromDate: null,
    toDate: null,
    fromUsername: '',
    toUsername: '',
    transactionType: '',
    greaterThan: '',
    exportData: [],
    exporting: false,
  }

  resetFilters = () => {
    this.setState({
      fromDate: null,
      toDate: null,
      fromUsername: '',
      toUsername: '',
      transactionType: '',
      greaterThan: '',
      page: 1,
    });
  }

  onOk = () => {
    this.setState({ open: false });
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page + 1 }, () => {
      this.refetchData();
    }); // Material-UI uses 0-indexed, server uses 1-indexed
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value, page: 1 }, () => {
      this.refetchData();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Refetch when filters or pagination change
    const { page, limit, fromDate, toDate, fromUsername, toUsername, transactionType, greaterThan } = this.state;
    if (
      prevState.page !== page ||
      prevState.limit !== limit ||
      prevState.fromDate !== fromDate ||
      prevState.toDate !== toDate ||
      prevState.fromUsername !== fromUsername ||
      prevState.toUsername !== toUsername ||
      prevState.transactionType !== transactionType ||
      prevState.greaterThan !== greaterThan
    ) {
      this.refetchData();
    }
  }

  refetchData = () => {
    const { refetch } = this.props;
    if (refetch) {
      const { page, limit } = this.state;
      refetch({
        input: {
          ...this.buildFiltersInput(),
          page: page || 1,
          limit: limit || 15,
        }
      });
    }
  }

  buildFiltersInput = () => {
    const {
      fromDate, toDate, fromUsername, toUsername, transactionType, greaterThan,
    } = this.state;
    return {
      fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
      toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
      fromUsername: fromUsername || null,
      toUsername: toUsername || null,
      transactionType: transactionType || null,
      greaterThan: greaterThan ? parseFloat(greaterThan) : null,
    };
  }

  getFromType = (movement) => {
    if (movement.fromUser) {
      if (movement.fromUser.role === 'ADMIN') return 'Admin';
      if (movement.fromUser.role === 'MERCHANT') return 'Merch';
      if (movement.fromUser.role === 'CONSUMER') return 'Cons';
    }
    if (movement.merchant) return 'Merch';
    if (movement.consumer) return 'Cons';
    return '-';
  }

  getToType = (movement) => {
    if (movement.toUser) {
      if (movement.toUser.role === 'ADMIN') return 'Admin';
      if (movement.toUser.role === 'MERCHANT') return 'Merch';
      if (movement.toUser.role === 'CONSUMER') return 'Cons';
    }
    if (movement.merchant) return 'Merch';
    if (movement.consumer) return 'Cons';
    return '-';
  }

  getFromUsername = (movement) => {
    if (movement.fromUser) return movement.fromUser.username || '';
    if (movement.merchant) return movement.merchant.username || '';
    if (movement.consumer) return movement.consumer.username || '';
    return '-';
  }

  getToUsername = (movement) => {
    if (movement.toUser) return movement.toUser.username || '';
    if (movement.merchant) return movement.merchant.username || '';
    if (movement.consumer) return movement.consumer.username || '';
    return '-';
  }

  getComment = (movement) => {
    // Use comment from backend if available
    if (movement.comment) return movement.comment;
    // Fallback to type if no comment
    return movement.type || '-';
  }

  prepareDataForCSV = (movements = []) => {
    // Prepare data for CSV
    let data = [];
    movements.forEach(movement => {
      const date = movement.createdAt ? moment(Number(movement.createdAt)) : null;
      data.push({
        Date: date ? date.format('MM/DD/YYYY') : '',
        Time: date ? date.format('HH:mm') : '',
        Amount: movement.amount != null ? parseFloat(movement.amount).toFixed(2) : '',
        'From Type': this.getFromType(movement),
        'From Username': this.getFromUsername(movement),
        'To Type': this.getToType(movement),
        'To Username': this.getToUsername(movement),
        'Transaction Type': movement.type || '',
        Comment: this.getComment(movement),
      });
    });

    // Sort by date descending
    data = _.orderBy(data, obj => {
      if (obj.Date && obj.Time) {
        return moment(`${obj.Date} ${obj.Time}`, 'MM/DD/YYYY HH:mm').valueOf();
      }
      return 0;
    }, 'desc');

    return data;
  }


  onExportToCSV = () => {
    const { client } = this.props;
    const { limit } = this.state;
    if (!client) return;

    this.setState({ exporting: true }, async () => {
      try {
        const baseInput = {
          ...this.buildFiltersInput(),
          page: 1,
          limit: limit || 15,
        };

        const firstResult = await client.query({
          query: getAllDealCoinsMovements,
          variables: { input: baseInput },
          fetchPolicy: 'no-cache',
        });
        const firstPayload = firstResult && firstResult.data
          ? firstResult.data.getAllDealCoinsMovements
          : null;

        if (!firstPayload || !firstPayload.count_rows) {
          this.setState({ exporting: false, exportData: [] });
          return;
        }

        let allMovements = (firstPayload.movements || []).slice();
        const totalPage = firstPayload.total_page || 1;

        for (let currentPage = 2; currentPage <= totalPage; currentPage += 1) {
          const pageResult = await client.query({
            query: getAllDealCoinsMovements,
            variables: {
              input: {
                ...baseInput,
                page: currentPage,
              },
            },
            fetchPolicy: 'no-cache',
          });
          const pagePayload = pageResult && pageResult.data
            ? pageResult.data.getAllDealCoinsMovements
            : null;
          if (pagePayload && pagePayload.movements && pagePayload.movements.length) {
            allMovements = allMovements.concat(pagePayload.movements);
          }
        }

        const exportData = this.prepareDataForCSV(allMovements);
        this.setState({ exportData, exporting: false }, () => {
          if (this.csvLinkRef) {
            this.csvLinkRef.link.click();
          }
        });
      } catch (error) {
        this.setState({ exporting: false });
      }
    });
  }

  renderExportButtonLabel = () => {
    const { classes } = this.props;
    const { exporting } = this.state;
    return (
      <Typography component="p" className={classes.text}>
        {exporting ? 'Exporting...' : 'Export'}
      </Typography>
    );
  }

  _renderToolBar = () => {
    const { classes } = this.props;
    const {
      fromDate, toDate, fromUsername, toUsername, transactionType, greaterThan, exportData, exporting,
    } = this.state;
    const { getAllDealCoinsMovements } = this.props;
    const countRows = (getAllDealCoinsMovements && getAllDealCoinsMovements.count_rows) || 0;

    return (
      <>
        <div className={classes.searchWrapper}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <CustomInput
              formControlProps={{
                className: `${classes.margin} ${classes.search}`,
              }}
              inputProps={{
                value: fromUsername,
                onChange: (e) => this.setState({ fromUsername: e.target.value, page: 1 }),
                placeholder: 'From Username',
                inputProps: {
                  'aria-label': 'From Username',
                },
              }}
            />
            <Button disabled>
              <Search />
            </Button>
            <CustomInput
              formControlProps={{
                className: `${classes.margin} ${classes.search}`,
              }}
              inputProps={{
                value: toUsername,
                onChange: (e) => this.setState({ toUsername: e.target.value, page: 1 }),
                placeholder: 'To Username',
                inputProps: {
                  'aria-label': 'To Username',
                },
              }}
            />
            <Button disabled>
              <Search />
            </Button>
            <FormControl style={{ minWidth: 150 }}>
              <InputLabel shrink>Transaction Type</InputLabel>
              <Select
                value={transactionType}
                onChange={(e) => this.setState({ transactionType: e.target.value, page: 1 })}
                displayEmpty
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="CLOSED_DEAL">Closed Deal</MenuItem>
                <MenuItem value="CASHED_DEAL">Cashed Deal</MenuItem>
                <MenuItem value="TRANSFER_SENT">Transfer Sent</MenuItem>
                <MenuItem value="TRANSFER_RECEIVED">Transfer Received</MenuItem>
                <MenuItem value="PAYMENT_METHOD">Payment Method</MenuItem>
                <MenuItem value="TDC_CREDIT">TDC Credit</MenuItem>
                <MenuItem value="RDC_CREDIT">RDC Credit</MenuItem>
                <MenuItem value="EDC_CREDIT">EDC Credit</MenuItem>
                <MenuItem value="REWARD_CREDIT">Reward Credit</MenuItem>
                <MenuItem value="CANCEL">Cancel</MenuItem>
                <MenuItem value="COUPON">Coupon</MenuItem>
                <MenuItem value="SIGNUP">Signup</MenuItem>
                <MenuItem value="SHARED">Shared</MenuItem>
                <MenuItem value="DEPOSIT">Deposit</MenuItem>
                <MenuItem value="REFUND">Refund</MenuItem>
                <MenuItem value="REFERAL_EARNED">Referral Earned</MenuItem>
              </Select>
            </FormControl>
            <TextField
              type="number"
              label="Greater Than"
              value={greaterThan}
              onChange={(e) => this.setState({ greaterThan: e.target.value, page: 1 })}
              style={{ minWidth: 120 }}
            />
            <Button variant="contained" color="primary" className={classes.button} onClick={this.onExportToCSV} disabled={exporting}>
              {this.renderExportButtonLabel()}
              <FaFileExport color="#ffffff" size={16} />
            </Button>
            <CSVLink
              data={exportData}
              filename={`dealcoins-movements-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
              style={{ display: 'none' }}
              ref={(r) => { this.csvLinkRef = r; }}
            >
              Export
            </CSVLink>
          </div>
          <Typography component="p" style={{ fontSize: '14px', alignSelf: 'center' }}>
            Rows: {countRows}
          </Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.filterLabel}>Date Filter</Typography>
          <Grid key="date-filter" container>
            <Grid key="from" container item xs={12} md={8}>
              <Grid item xs={12} sm={6}>
                <InlineDatePicker
                  label="From"
                  id="date-from"
                  onChange={(date) => this.setState({ fromDate: date, page: 1 })}
                  format="yyyy-MM-dd"
                  value={fromDate}
                />
              </Grid>
              <Grid key="to" item xs={12} sm={6}>
                <InlineDatePicker
                  label="To"
                  id="date-to"
                  onChange={(date) => this.setState({ toDate: date, page: 1 })}
                  format="yyyy-MM-dd"
                  value={toDate}
                />
              </Grid>
            </Grid>
            <Grid key="reset-date-filter" container item xs={12} md={4}>
              <Button variant="contained" color="primary" className={classes.button} onClick={this.resetFilters}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </div>
      </>
    );
  }

  render() {
    const { classes, getAllDealCoinsMovements } = this.props;
    const movements = (getAllDealCoinsMovements && getAllDealCoinsMovements.movements) || [];
    const pagination = getAllDealCoinsMovements || {};
    
    const {
      title, content, open, page, limit, fromDate, toDate, fromUsername, toUsername, transactionType, greaterThan,
    } = this.state;

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div>
          <Dialog
            title={title}
            content={content}
            open={open}
            onOk={() => this.onOk()}
          />
          {this._renderToolBar()}
          <Paper className={classes.root}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <CustomTableCell>Date</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Time</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Amount</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>From Type</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>From Username</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>To Type</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>To Username</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Transaction Type</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Comment</CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {movements.map((row) => {
                const date = row.createdAt ? moment(Number(row.createdAt)) : null;
                  return (
                    <TableRow className={classes.row} key={row.id}>
                      <CustomTableCell component="th" scope="row">
                        {date ? date.format('MM/DD/YYYY') : '-'}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {date ? date.format('HH:mm') : '-'}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {row.amount != null ? parseFloat(row.amount).toFixed(2) : '-'}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {this.getFromType(row)}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {this.getFromUsername(row)}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {this.getToType(row)}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {this.getToUsername(row)}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {row.type || '-'}
                      </CustomTableCell>
                      <CustomTableCell align="right" className={classes.colTable}>
                        {this.getComment(row)}
                      </CustomTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[15, 25, 50]}
              component="div"
              count={pagination.count_rows || 0}
              rowsPerPage={limit}
              page={page - 1}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

// Mark: default props
TableDealCoins.defaultProps = {
  classes: {},
  getAllDealCoinsMovements: [],
};

// Mark: PropsType
TableDealCoins.propTypes = {
  classes: PropTypes.object,
  getAllDealCoinsMovements: PropTypes.object,
  refetch: PropTypes.func,
  client: PropTypes.object,
};

// Mark: Map data grapql to props
const AllDealCoinsMovements = graphql(getAllDealCoinsMovements, {
  options: () => ({
    variables: {
      input: {
        page: 1,
        limit: 15,
        fromDate: null,
        toDate: null,
        fromUsername: null,
        toUsername: null,
        transactionType: null,
        greaterThan: null,
      }
    },
    fetchPolicy: 'network-only',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    getAllDealCoinsMovements: data.getAllDealCoinsMovements,
    refetch: data.refetch,
  }),
});

export default withStyles(styles)(compose(AllDealCoinsMovements, withApollo)(TableDealCoins));
